// extracted by mini-css-extract-plugin
export default {"mainTitle":"sharedStyles_mainTitle__ojD-i"};